import { Icon, IconProps } from "../";

export const ArrowForwardIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9697 6.53033C11.6768 6.23744 11.6768 5.76256 11.9697 5.46967C12.2626 5.17678 12.7374 5.17678 13.0303 5.46967L19.0303 11.4697C19.3232 11.7626 19.3232 12.2374 19.0303 12.5303L13.0303 18.5303C12.7374 18.8232 12.2626 18.8232 11.9697 18.5303C11.6768 18.2374 11.6768 17.7626 11.9697 17.4697L16.6893 12.75H5.25C4.83579 12.75 4.5 12.4142 4.5 12C4.5 11.5858 4.83579 11.25 5.25 11.25H16.6893L11.9697 6.53033Z"
      />
    </Icon>
  );
};
